import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {BoxedInputChildProps} from '../../../../libs/shared/ui/src/components/boxedInputs/boxedInputConstants';

/*
 * Props.
 */

export interface BoxedInputToolbarProps extends BoxedInputChildProps {
  children: ReactNode;
}

/*
 * Style.
 */

const StyledToolbarDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 7px 4px 0px 4px;
`;

/*
 * Component.
 */

export const BoxedInputToolbar: FC<BoxedInputToolbarProps> = (props) => (
  <StyledToolbarDiv>{props.children}</StyledToolbarDiv>
);
